import React, { Component } from 'react'

import filter from 'lodash/filter'

import DeailtRow from './DetailRow'

import './SummaryContent.css'

class SummaryContent extends Component {

    /* Methods */
    getDetailRowStyle = (dataType) => {

        if(this.props.currentSelection.dataType) {
            if(this.props.currentSelection.dataType == dataType) return { opacity: 1 }
            else return { opacity: 0.5 }
        }
        return { opacity: 1 }
    }

    /* Handlers */

    /* Lifecycle */
     
    render() {

        const { region, data } = this.props
        const { detailHover } = this.props

        const filteredData = filter(data, {region: region})

        return (
            <div className="pages-shared-data-visualizer-summary-content">
                {
                    filteredData.map((data, index)=>{

                        const { data_type } = data

                        return (
                            <div key={index}
                                 style={this.getDetailRowStyle(data_type)}
                                 onMouseEnter={() => detailHover(data_type, 'enter')}
                                 onMouseLeave={() => detailHover(data_type, 'leave')}
                                 onTouchStart={() => detailHover(data_type, 'enter')}>
                                <DeailtRow data={data}/>
                            </div> 
                        )
                    })
                }
            </div>       
        )
    }
}

export default SummaryContent


// WEBPACK FOOTER //
// ./src/components/pages/shared/data_visualizer/SummaryContent.js